<template>
  <span>
    Acesso de suporte de {{ support.issuedBy }} em {{ support.customerName }}.
    <template v-if="remaining > 0">Expira em {{ countdown }}.</template>
    <template v-else>Sessão expirada.</template>
  </span>
</template>

<script>
import moment from 'moment';

export default {
  name: 'SupportSessionBar',
  props: {
    support: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      remaining: 0,
      intervalId: null,
    };
  },
  computed: {
    countdown() {
      const minutes = Math.floor(this.remaining / 60);
      const seconds = this.remaining % 60;
      return `${minutes}:${String(seconds).padStart(2, '0')}`;
    },
  },
  mounted() {
    this.tick();
    this.intervalId = setInterval(this.tick, 1000);
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods: {
    tick() {
      const seconds = moment(this.support.expiresAt).diff(moment(), 'seconds');
      this.remaining = Math.max(seconds, 0);
    },
  },
};
</script>
